package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class NotebookQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    name: String,
    icon: String,
    color: String,
    parent_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-1_265_159_952, arrayOf("notebook"), driver, "Notebook.sq", "selectAll",
      "SELECT notebook.id, notebook.name, notebook.icon, notebook.color, notebook.parent_id, notebook.order_index, notebook.created_at, notebook.updated_at, notebook.is_deleted, notebook.deleted_at, notebook.synced_at FROM notebook WHERE is_deleted = 0 ORDER BY order_index, name") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectAll(): Query<Notebook> = selectAll { id, name, icon, color, parent_id,
      order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Notebook(
      id,
      name,
      icon,
      color,
      parent_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    name: String,
    icon: String,
    color: String,
    parent_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectById(id: String): Query<Notebook> = selectById(id) { id_, name, icon, color,
      parent_id, order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Notebook(
      id_,
      name,
      icon,
      color,
      parent_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    name: String,
    icon: String,
    color: String,
    parent_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-340_278_431, arrayOf("notebook"), driver, "Notebook.sq", "selectDirty",
      "SELECT notebook.id, notebook.name, notebook.icon, notebook.color, notebook.parent_id, notebook.order_index, notebook.created_at, notebook.updated_at, notebook.is_deleted, notebook.deleted_at, notebook.synced_at FROM notebook WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectDirty(): Query<Notebook> = selectDirty { id, name, icon, color, parent_id,
      order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Notebook(
      id,
      name,
      icon,
      color,
      parent_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    name: String,
    icon: String,
    color: String,
    parent_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4),
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8)!!,
      cursor.getLong(9),
      cursor.getLong(10)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Notebook> = selectByIdAnyState(id) { id_, name,
      icon, color, parent_id, order_index, created_at, updated_at, is_deleted, deleted_at,
      synced_at ->
    Notebook(
      id_,
      name,
      icon,
      color,
      parent_id,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    name: String,
    icon: String,
    color: String,
    parent_id: String?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(-757_322_578, """
        |INSERT INTO notebook(id, name, icon, color, parent_id, order_index, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 8) {
          bindString(0, id)
          bindString(1, name)
          bindString(2, icon)
          bindString(3, color)
          bindString(4, parent_id)
          bindLong(5, order_index)
          bindLong(6, created_at)
          bindLong(7, updated_at)
        }
    notifyQueries(-757_322_578) { emit ->
      emit("notebook")
    }
  }

  public fun update(
    name: String,
    icon: String,
    color: String,
    parent_id: String?,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-412_376_386, """
        |UPDATE notebook
        |SET name = ?, icon = ?, color = ?, parent_id = ?, order_index = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 7) {
          bindString(0, name)
          bindString(1, icon)
          bindString(2, color)
          bindString(3, parent_id)
          bindLong(4, order_index)
          bindLong(5, updated_at)
          bindString(6, id)
        }
    notifyQueries(-412_376_386) { emit ->
      emit("notebook")
    }
  }

  public fun setParent(
    parent_id: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(936_818_071,
        """UPDATE notebook SET parent_id = ?, updated_at = ? WHERE id = ?""", 3) {
          bindString(0, parent_id)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(936_818_071) { emit ->
      emit("notebook")
    }
  }

  public fun rename(
    name: String,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-508_124_877, """UPDATE notebook SET name = ?, updated_at = ? WHERE id = ?""", 3)
        {
          bindString(0, name)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-508_124_877) { emit ->
      emit("notebook")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(495_683_050,
        """UPDATE notebook SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(495_683_050) { emit ->
      emit("notebook")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(1_433_184_057,
        """UPDATE notebook SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""", 2)
        {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(1_433_184_057) { emit ->
      emit("notebook")
    }
  }

  public fun hardDelete(id: String) {
    driver.execute(315_620_843, """DELETE FROM notebook WHERE id = ?""", 1) {
          bindString(0, id)
        }
    notifyQueries(315_620_843) { emit ->
      emit("notebook")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(1_698_576_668,
        """UPDATE notebook SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(1_698_576_668) { emit ->
      emit("notebook")
    }
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("notebook", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("notebook", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-565_211_549,
        """SELECT notebook.id, notebook.name, notebook.icon, notebook.color, notebook.parent_id, notebook.order_index, notebook.created_at, notebook.updated_at, notebook.is_deleted, notebook.deleted_at, notebook.synced_at FROM notebook WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Notebook.sq:selectById"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("notebook", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("notebook", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(1_505_004_936,
        """SELECT notebook.id, notebook.name, notebook.icon, notebook.color, notebook.parent_id, notebook.order_index, notebook.created_at, notebook.updated_at, notebook.is_deleted, notebook.deleted_at, notebook.synced_at FROM notebook WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Notebook.sq:selectByIdAnyState"
  }
}
